export const MODIFY_VIZ_INFO = 'MODIFY_VIZ_INFO';

export function modifyVizInfo(vizInfo){
    return{
        type: MODIFY_VIZ_INFO,
        mainState: {
            vizInfo: vizInfo
        }
    }
}